var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("w-select", {
        ref: "select",
        attrs: {
          items: _vm.items,
          value: _vm.value,
          fancy: "",
          label: _vm.compLabel,
          disabled: _vm.disabled,
        },
        on: {
          input: _vm.onChange,
          keyup: function ($event) {
            return _vm.onKeyUp($event)
          },
        },
      })
    : _c("w-multi-select", {
        ref: "select",
        attrs: {
          value: _vm.value,
          items: _vm.items,
          fancy: "",
          label: _vm.label,
          disabled: _vm.disabled,
        },
        on: {
          input: _vm.onChange,
          keyup: function ($event) {
            return _vm.onKeyUp($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }